





































import Vue, { PropType } from 'vue';
import {
  Option,
  options,
  Story,
} from 'mostra';

export type DataType = {
  carouselType: Option;
};

export default Vue.extend({
  name: 'GStoryGalleryForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    story: {
      type: Object as PropType<Story[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      carouselType: options.carouselType,
    };
  },
});
